import { Expose, Type } from 'class-transformer';
import { SubscriptionStatusEnum } from './subscription-status.enum';
import { GetSubscriptionSubCategoryDto } from './get-subscription-sub-category.dto';

export class GetSubscriptionResponseDto {
  @Expose({ name: 'id' })
  id: number;
  @Expose({ name: 'name' })
  name: string;
  @Expose({ name: 'category_objects' })
  @Type(() => GetSubscriptionSubCategoryDto)
  categoryObjects: GetSubscriptionSubCategoryDto[];
  @Expose({ name: 'location_id' })
  locationId: number;
  @Expose({ name: 'description' })
  description: string;
  @Expose({ name: 'price' })
  price: number;
  @Expose({ name: 'from_date' })
  fromDate: number;
  @Expose({ name: 'to_date' })
  toDate: number;
  @Expose({ name: 'to_date' })
  image: string;
  @Expose({ name: 'catalog_number' })
  catalogNumber: string;
  @Expose({ name: 'policy_id' })
  policyId: number;
  @Expose({ name: 'status' })
  status: SubscriptionStatusEnum;
  @Expose({ name: 'memberships' })
  memberships: any[];
}
